'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numbro = require('numbro');

var _numbro2 = _interopRequireDefault(_numbro);

var _orderBy = require('lodash/orderBy');

var _orderBy2 = _interopRequireDefault(_orderBy);

var _teams = require('../../api/teams');

var _fitness = require('../../utils/fitness');

var _grid = require('constructicon/grid');

var _grid2 = _interopRequireDefault(_grid);

var _leaderboardItem = require('constructicon/leaderboard-item');

var _leaderboardItem2 = _interopRequireDefault(_leaderboardItem);

var _leaderboard = require('constructicon/leaderboard');

var _leaderboard2 = _interopRequireDefault(_leaderboard);

var _pagination = require('constructicon/pagination');

var _pagination2 = _interopRequireDefault(_pagination);

var _paginationLink = require('constructicon/pagination-link');

var _paginationLink2 = _interopRequireDefault(_paginationLink);

var _richText = require('constructicon/rich-text');

var _richText2 = _interopRequireDefault(_richText);

var _section = require('constructicon/section');

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeamLeaderboard = function TeamLeaderboard(_ref) {
  var activeOnly = _ref.activeOnly,
      deserializeMethod = _ref.deserializeMethod,
      leaderboard = _ref.leaderboard,
      leaderboardItem = _ref.leaderboardItem,
      limit = _ref.limit,
      miles = _ref.miles,
      multiplier = _ref.multiplier,
      offset = _ref.offset,
      pageSize = _ref.pageSize,
      refreshInterval = _ref.refreshInterval,
      showPage = _ref.showPage,
      sortBy = _ref.sortBy,
      subtitleMethod = _ref.subtitleMethod,
      team = _ref.team,
      units = _ref.units;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      pages = _useState2[0],
      setPages = _useState2[1];

  var _useState3 = (0, _react.useState)('fetching'),
      _useState4 = _slicedToArray(_useState3, 2),
      status = _useState4[0],
      setStatus = _useState4[1];

  var sortKeys = {
    activities: 'fitnessCount',
    distance: 'fitnessDistanceTotal',
    duration: 'fitnessDurationTotal',
    elevation: 'fitnessElevationTotal'
  };

  var sortKey = sortKeys[sortBy] || 'raised';

  var sortedPages = (0, _orderBy2.default)(pages, [sortKey], ['desc']).map(function (page, index) {
    return _extends({}, page, { position: index + 1 });
  }).slice(0, limit);

  var renderAmount = function renderAmount(page, format) {
    var amount = (offset + page[sortKey]) * multiplier;

    if (units) {
      switch (sortBy) {
        case 'activities':
          return (0, _fitness.formatActivities)(amount);
        case 'distance':
          return (0, _fitness.formatDistance)(amount, miles, format);
        case 'duration':
          return (0, _fitness.formatDuration)(amount, format);
        case 'elevation':
          return (0, _fitness.formatElevation)(amount, miles, format);
        default:
          return (0, _numbro2.default)(amount).formatCurrency('0,0');
      }
    }

    return (0, _numbro2.default)(amount).format('0,0');
  };

  var fetchData = function fetchData() {
    return (0, _teams.fetchTeamPages)(team).then(function (data) {
      return data.map(deserializeMethod || _teams.deserializeTeamPage);
    }).then(function (pages) {
      return activeOnly ? pages.filter(function (page) {
        return page.active;
      }) : pages;
    }).then(setPages).then(function () {
      return setStatus('fetched');
    }).catch(function (error) {
      setStatus('failed');
      return Promise.reject(error);
    });
  };

  (0, _react.useEffect)(function () {
    fetchData();

    if (refreshInterval) {
      setInterval(fetchData, refreshInterval);
    }
  }, []);

  if (status === 'fetching' || status === 'failed') {
    return _react2.default.createElement(_leaderboard2.default, _extends({}, leaderboard, {
      loading: status === 'fetching',
      error: status === 'failed'
    }));
  }

  if (!pages.length) return _react2.default.createElement(_leaderboard2.default, _extends({}, leaderboard, { empty: true }));

  return _react2.default.createElement(
    _pagination2.default,
    { max: pageSize, toPaginate: sortedPages },
    function (_ref2) {
      var currentPage = _ref2.currentPage,
          isPaginated = _ref2.isPaginated,
          prev = _ref2.prev,
          next = _ref2.next,
          canPrev = _ref2.canPrev,
          canNext = _ref2.canNext,
          pageOf = _ref2.pageOf;
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          _leaderboard2.default,
          leaderboard,
          currentPage.map(function (page, i) {
            return _react2.default.createElement(_leaderboardItem2.default, _extends({}, leaderboardItem, {
              key: i,
              title: page.name,
              image: page.image,
              amount: renderAmount(page),
              amountLabel: renderAmount(page, 'full'),
              href: page.url,
              rank: page.position,
              subtitle: subtitleMethod(page)
            }));
          })
        ),
        pageSize && isPaginated && _react2.default.createElement(
          _section2.default,
          { spacing: { t: 0.5 } },
          _react2.default.createElement(
            _grid2.default,
            { align: 'center', justify: 'center' },
            _react2.default.createElement(_paginationLink2.default, {
              onClick: prev,
              direction: 'prev',
              disabled: !canPrev
            }),
            showPage && _react2.default.createElement(
              _richText2.default,
              { size: -1 },
              pageOf
            ),
            _react2.default.createElement(_paginationLink2.default, {
              onClick: next,
              direction: 'next',
              disabled: !canNext
            })
          )
        )
      );
    }
  );
};

TeamLeaderboard.propTypes = {
  /**
   * The team slug to fetch pages for
   */
  team: _propTypes2.default.string.isRequired,

  /**
   * Use imperial units (miles, feet, yards)
   */
  miles: _propTypes2.default.bool,

  /**
   * The max number of records to show
   */
  limit: _propTypes2.default.number,

  /**
   * The number of records to show per page, disables pagination if not specified.
   */
  pageSize: _propTypes2.default.number,

  /**
   * Override the deserializeTeamPage method
   */
  deserializeMethod: _propTypes2.default.func,

  /**
   * The type of measurement to sort by
   */
  sortBy: _propTypes2.default.oneOf(['distance', 'duration', 'elevation', 'activities', 'raised']),

  /**
   * Props to be passed to the Constructicon Leaderboard component
   */
  leaderboard: _propTypes2.default.object,

  /**
   * Props to be passed to the Constructicon LeaderboardItem component
   */
  leaderboardItem: _propTypes2.default.object,

  /**
   * Include distance units?
   */
  units: _propTypes2.default.bool,

  /**
   * Only show active pages?
   */
  activeOnly: _propTypes2.default.bool,

  /**
   * Offset to be applied to each page distance
   */
  offset: _propTypes2.default.number,

  /**
   * The amount to multiply each page distance by for custom conversions
   */
  multiplier: _propTypes2.default.number,

  /**
   * Interval (in milliseconds) to refresh data from API
   */
  refreshInterval: _propTypes2.default.number,

  /**
   * A function to determine which subtitle to show
   */
  subtitleMethod: _propTypes2.default.func
};

TeamLeaderboard.defaultProps = {
  activeOnly: true,
  limit: 250,
  multiplier: 1,
  offset: 0,
  pageSize: 10,
  showPage: true,
  sortBy: 'raised',
  subtitleMethod: function subtitleMethod(item) {
    return item.subtitle;
  },
  units: true
};

exports.default = TeamLeaderboard;